module.exports = __webpack_public_path__ + "static/media/headerLogo.6a762207.png";